import ContactsLocations from "./components/ContactsLocations";
import React from "react";
import ReactRegisterComponent from "./helpers/ReactRegisterComponent";

new ReactRegisterComponent(<ContactsLocations />, "ContactsLocations");
